import React, { Component } from 'react';
import { notification, Icon, Popover, Badge } from 'antd';
import { connect } from 'react-redux';
import WaitList from './Help/WaitList';
// const moment = require('moment');


class HelpButton extends Component {
  state = {
    request: null,
    requestList: []
  }

  componentDidMount() {
    const { batchId } = this.props;

    if (global.SOCKET) {
      global.SOCKET.on('solvedRequest', this.solvedRequest);
      //global.SOCKET.on('studentCancelRequest', this.studentCancelRequest);
      // global.SOCKET.on('helperAssists', this.helperAssists);
      global.SOCKET.on('requestMonitoring', this.requestMonitoring);
      global.SOCKET.on('newRequest', this.newRequest);
      global.SOCKET.on('change', this.change);
      global.SOCKET.emit('requestMonitoring', { batchId })
      global.SOCKET.on('backHelpStats', this.backHelpStats);
      global.SOCKET.on('currentStats', this.currentStats);
    }
  }

  componentWillUnmount() {
    if (global.SOCKET) {
      global.SOCKET.off('solvedRequest', this.solvedRequest);
      //global.SOCKET.off('studentCancelRequest', this.studentCancelRequest);
      // global.SOCKET.off('helperAssists', this.helperAssists);
      global.SOCKET.off('requestMonitoring', this.requestMonitoring);
      global.SOCKET.off('newRequest', this.newRequest);
      global.SOCKET.off('change', this.change);
      global.SOCKET.off('backHelpStats', this.backHelpStats);
      global.SOCKET.off('currentStats', this.currentStats);


    }
  }

  currentStats = currentRequests => {

    console.log("CURRENT REQUESTS", currentRequests.length)

  }

  backHelpStats = data => {

    // const individualHelpStats = data[0];
    const dailyGlobalHelpStat = data[1];
    // const cumulatedStudentLiveRequests = data[2];
    // const cumulatedWeeklyRequestsStats = data[3];
    // const today = moment().format("DD/MM/YYYY");

    let helpStatsOfTheDay = {};
    // let dailyStudentHelpStats = [];
    // let dailyHelpersStats = [];

    for (const e of dailyGlobalHelpStat) {
      if (e.date) {
        helpStatsOfTheDay = {averageDuration: Math.round(e.averageDuration), totalMinutes: e.totalMinutes, totalRequests: e.totalRequests}
      }
    }

    /* for (const e of individualHelpStats) {
      if(e._id.userType == 'student') {
        const student = {userId: e._id.userId, fullname: e._id.firstname + ' ' + e._id.lastname, totalMinutes: e._id.totalMinutes, totalRequests: e._id.totalRequests}
        dailyStudentHelpStats.push(student);
      } else {
        const helpers = {userId: e._id.userId, fullname: e._id.firstname + ' ' + e._id.lastname, averageMinutes: Math.round(e._id.totalMinutes / e._id.totalRequests), totalRequests: e._id.totalRequests}
        dailyHelpersStats.push(helpers);
      }
    } */
    //console.log("STUDENTS", dailyStudentHelpStats)
    //console.log("HELPERS", dailyHelpersStats)
    //console.log("CUMULATED STUDENT DA", cumulatedStudentLiveRequests);
    //console.log("CUMULATED WEEK DA", cumulatedWeeklyRequestsStats);

  }

  // Quand une demande est fermée par l'étudiant - et par teacher ? 
  solvedRequest = data => {
    const { user, batchId } = this.props;

    if (data.success && data.student && data?.to?.indexOf(user._id) !== -1) {
      if (data?.request?.userId === user._id) this.resetIndicator();
      else this._closedTicket();
    }

    global.SOCKET.emit('requestMonitoring', { batchId });
  }

/*   studentCancelRequest = data => {
    const { user } = this.props;
    console.log("STUDENT CANCEL", data);


    if (data?.to?.indexOf(user._id) !== -1) this._closedTicket(false);
  } */

  // helperAssists(data) {
  //   const { user } = this.props;

  //   if (data.success === true) {
  //     if (data.student._id === user._id) {
  //       this._teacherTriggeredRequest();
  //     };
  //   } else {
  //     return null;
  //   };
  // }

  change = data => {
    const { _isStatusAway, user, batchId } = this.props;
    if (data.success && data.status && data?.to?.indexOf(user._id) !== -1) {
      _isStatusAway(data.status);
    } else if (data.status && !data.success && data?.to?.indexOf(user._id !== -1)) {
      global.SOCKET.emit("change", { teacherId: user._id, status: data.status, batchId })
    }
  }

  requestMonitoring = data => {
    const { user } = this.props;
    if (data.requests) {
      this.setState({ request: data.requests, requestList: data.requests });
    }
  }

  newRequest = data => {
    const { user } = this.props;

    if (data?.to?.indexOf(user._id) !== -1 && data?.teacherId === user._id) {
      this.openNotificationToTeacher('info', data?.request?._id, data?.request?.firstname + ' ' +  data?.request?.lastname);
      this.setIndicator();
    }
  }


  openNotificationToStudent = type => {
    let description = null;

    if (type === 'info') description = 'Un teacher vous vient en aide';
    else if (type === 'success') description = 'La demande a été clôturée';

    notification[type]({ message: 'Help Me!', description: description });
  }

  openNotificationToTeacher = (type, id, name) => {
    let description = null;

    if (type === 'info') description = (name ? name : 'Un étudiant') + ' a besoin de votre aide';

    try {
      if (Notification.permission !== "granted") notification[type]({ message: 'Help Me!', description: description });
      else new Notification(description, { tag: id, /* renotify: true */ });
    } catch (e) {
      notification[type]({ message: 'Help Me!', description: description });
    }
  }

  resetIndicator() {
    document.querySelectorAll('[rel="shortcut icon"]')[0].href = "data:image/png;base64,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";
    fetch('http://localhost:8934/blink1/off').then(res => res.json()).then(data => { console.log(data) }).catch(err => console.error(err));
  }

  setIndicator() {
    document.querySelectorAll('[rel="shortcut icon"]')[0].href = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAANXHpUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHjarZhpciS7DYT/8xQ+AjcQ5HG4RvgGPr4/sErSaGbeYsdTS92tahYXIJGZaLf/8+/j/sVPkhRdFq2lleL5yS232HlT/fPzvAaf7/P9ie9H/P/tuvv8IHIp8Zqef8t+x3euy9cNmt/r4/t1p/Odp74TBf9t6WQr2/t3XH0nSvG5Ht7/XXvv6/mH47x/cb7Tfhzrp/+zEowlzEeM4k4heZ6LrZLYQaqp27X7zMLvlZQaz9HG/S527vPtT8H7fPdT7Hx/r6fvoXC+vAPKTzF6rwf56Xr6XCZ+21H4WvnbB6N8hPfX2J2z6jn7OV3PhUgV9x7q4yj3HQMHoUz3tsJD+RPe6300HpUjTjK2WG7wmC60EInsCTms0MMJ+77OMNlijjsqrzHOmO61mjS2OG9Ssj3CiUoaliMjMU2ylrgcP/cS7rrtrjdDZeUVGBkDkwXu+OXhfnfx/3l8TnSOxTYEXz9jxb6iYZptWObsmVEkJJw3pnLjex/uB9z4HxKbyKDcMFcO2P14phgSvrCVbp4T48Rn55/SCLreCQgRawubCYkM+BKShBK8xqghEMdKfjo7jynHQQaCSFzBHXKTUiE5Ndra3KPhjo0Sn8tQC4mQVJKSGgqFZOUs4EdzBUNdkmQnIkVUqjTpJZVcpJSixTiqa9KsokVVqzbtNdVcpZaqtdZWe4stQWHSSlPXamutdxbtTN25uzOi9xFHGnnIKENHHW30CXxmnjLL1Flnm33FlRblv8pSt+pqq++wgdLOW3bZuutuux+wdtLJR045euppp39m7c3q96yFnzL351kLb9YsY/mO06+scVn1Y4pgdCKWMzIWcyDjahkA0NFy5mvIOVrmLGe+RYpCIlkLYslZwTJGBvMOUU74zN1X5v40b07y/5S3+EeZc5a6fyJzzlL3Zu7XvP0ma6tfRUk3QVaFFlOfDsTGgF17HPscBp3q71vIOfa2Ypm9zrJldlZMIm3w21vZVQu0JHOdMo5PbmgnCJ74CCeVE8Pk8hzPxxzwnTn0saT3on52gr5toXdBG9FciyELvyZ1f/iqi2zMtTTOEZLtZmiGGreOM2yyqu7MkLbWfohxZ1ekj5XXPGX5k8Fa9acPsjcWd7Wwd5MdAOaKkm3kJtw9iKtheluwjbX5XcsreGmx9plPLhOAARQhpkfSkkJWVaN0Vi+d7RBeYrOHS0UhdZAWk1VcO2RNZAbpg+VQA1l4FRlzzbWPFrI5dikNsK2iAr1wvtaOg7JmWuShN9E9QEYzkPmtOZ5F7n3fm3t19pNr3weED1jwtDznIWYaz1jrOMCnDcyoEDOiugUgD84zDxDMBrw37Al1ujAhw7P3BbyUQO49Q/HD7ZFsz3ymc4kliDJtKg0Es9GwVpgNUO91NtyPAxGwLh08TdFEAs2dtebMpbFl1DIL5LqAK8uPvPu1KLXrSuadbDO1wwd81vjz5O9IDTIOYBV1vVm4ySjxHm1rkKkCkktYWltStSKZsAJgpuYFqt9gibP3LUxuOGWB4DpXpZwL/85vljZBSlt7gjpwmGQmYT7ZW2Ct0U7TglOaA/inNGu0DA1H5faTCoc+MjLYlQl9JCqLI2ro+QVShJQqIBLqMffY2GcveRRY6fRqOIJPtBAOv4uV1hyMGoC2tUzd9TtLQJngxX3DlMEriG0r+wmwOGEHPQ4A98O4DlIIDKxGpOKyMC4AbyGJK9dFVncbeMBm0KQm3ujE4eGjvB05JEwGFE9kmXA0yXtQeavEbsFX7m2F8PYxWK8UID8WhQHsW2WZk/Bd+KPLipEaSHvUfMNg+m01oxSLkeWqdbNTEtkJ4xSyp4pZ0kgyCElI0Mi5RGpPzQgB8ttQMYwdjVu3h9onKF2xCyFZ2ajhhjE2iAKXtRVv3R3hK7B5YuFB1jBngjUQS5xY6ii7YQkS4lFqXpyinE5hHi+Q9KHIR8qK9ZvEN1UoIYV+ICbQMphUwliDfWOt92RL7QDYYdVtwb/AqmqV32EEYuGogFk0rbNWuqU/qFkxHVP4ZGXWGRu52GKcTJmhE6pmM8tggtkY1ZAth1KwEPoACfjdySt43rDbgpK6okdmC+RUOR34F4IpdSCtS5CZVg0tTcJ2avP2UeecnOPMsTdksAuLMmElFqECyCvEc0BQRJBM601R+0qR8/2STPcHuoFrKIobpgmRyWmXJNk8JNmovk9CTqCAyCkVAjMDRJCtcB4RgSaz5fGm0d80NiRahkfFLPgwHoWIohvbgGxOmB8+rT5PdxDBH/QJOSkmksnk8ock52aKzrFIVbba4l9kYxu0O4qxHZs58I+x187DG8eMwyFZcx7Epa3C7tZsDF4Tmlg3hseEKBMpOlkjVnHJmIg1Hnna9DLH6xGIz4TM0MOU6BIxgc4XOEeE8oBi59mJimUsSYUhD7qX35CDTNPnZnI854a6iElMb8iZpQgMzgwWig9lgmdLyo6y6Mha2JLGHnAlSGFz5Y07cfEAMUCUICquetUTLsKNiWVBrCyDqhu1XTqH7IEHjEaGsDqMAtVYtzHSlvVseFEy1iFdfvMfr4eObZA1O0S5xwHkgaxgrLgB0u2ThIGLMxo1Bvhb8AvQdN9nsN1wHxvADc6uzlCBoeF6aUAd6OZZKXGU7MKTtDREgVhnsjJoIbjLMrwV92WmRE5iEy7rJRfMVGJET7VOy+qAlwfe1iSWAG8j7Gzo6xeixVKZgMbioloWkex26poIkqSma1EASD6pq0YEUg/QEKOLUlGgm25o4ahl2+yBmIjCfY6jeMJvRnQSNogLq5daZakDeXC8xBtsKZNYzTZggWdoECNO0TZMRRet7g8Nm64IpSTM4JD7HquDnA0MKjiVVE37SckBAfC/WxMcQFdeigc9yw5TwAn60YxiV+rsUxpj+q109GFSCjLnI3mZzo3xGHZquOHMGi6CMlCSD89TMQdW1Z00YBOyVUGxIpBbBAfHbeLEBxkZOX65WsxFE/6SEA254oNpoyJaCeOKNQpAzUdbEpMUUdKd7vnVVDU8gXL0NPLo4x+9Bpwa0ySkE4kIxnrB4vy5b7P+4uzYzbzegxnzCpwY7c9PZUXwtEH5gpkj20TZiHYYFRPYL+Gb2a3ibv4AzbGGirWBMJpPwOHDAgWHfdC9sRNuhnIoZA9tsRrAdNMQYH4ES3gcMoHJYOPsikiWbYbHRA+KUmMv1HRfhcAAVmL/pRD6ks/CqWdXfyxmxgczmpYMoKyFXt0zPzuiaqw1Fdv2stIlOpMyXs9XN8tdMUkHjcd+3WF7kR7ySB+F+FRjsceGmlW7qyK/GAkroqvqeMRNc3x8yw8lhXy9VD8rIUkZ0GFsLNw86uCIMVNVxWDgzTbva4JN/hB3ZzG4jH1g05io36ej0CtgB2dOvzBRBBMgbbA+OkoDQRKpCNuAuTSyZsZKDNYLl0OmpqUNjrHbsPWyRr0uDtJoM+N0vpdrpiO97xw8RkuLjWFlaIsa15osjtYPQUn0eSKeRg67Eg9uiELDJWDRb68DOONFK/1aq5iCbF3KSDSNuxaFKLEGzTgfPls0subcfynFGSoy/kTCfVAZzQrdMGPRKciMOUq1TQoGATQ+ncZeOMtNEizkyZbGiRIiSNXl2zrgnc1wl4cLFmHBtuhtmSaSUs1ZUyyoXjbJ6ySCCGc8PK+64TpaCOz6egplYlN3/apVDJG3pm5h4pc2IzZrCNiZN3e46Y0sVoyuHVtjS1mk6PvIGtBG0SiwGNfLXVi9Rpog5Wa7zlbsxsPlqQ/qYKwGIAloHmFZORtzmsElR8/GZNxOFQMLQx5TO3tPyDGr0KGFFuAVYugY+dsg0h6zPO5sPc2I96ZHJuNBqrUi64oTPTc3QCyONYItRiNKrwUJbI8mPC34SSD7Keo90/RPtZt5whRYYKGJ1I5u2NOtW2Y0iYumRK0HJ9CcMdxOG4aNXEdM6MIuPurcB7tpJIOd7gawRasMsguI8niDgpXFjsA1ZqLUDNBblYlKwKYEelMK8jbhPbW4rrm5xAB6sH7mFj+44Wvz1jlABN4yU9cOt+XuHtiPiZGNzHKnqN4IIIMjTCQzUQpY73iwd9dPqn09c6wxqdbu/TgonEUNw1s/TjWcNZD40TtqfI5ir3fjjLRxAovHarDFD9M0TftWqiKU6P9rNx7yx6DWL6kOZrsewFFlaEWDhhTrZ1Njl772cfvYxyG4dr8MCMbRnAcreofhzpFNVBPuaPbNC5DHeMGLuKyM08GhIKT5NtG47TTdJq7LAICBq+FhPIm+FHwse0Vijfl8xpRCdSYA+61M3vvPc6C0f/nl0d97dZCPEZjxN2mdak3LvoGe8B1mG+KNC3BtdB43plbg9nUGG8J9r+tNrYP09o0lRg5fYzRNSFArj2skOo9RSObu8LdPcbc6jYif4n6ZG67MLvxDZ3NIYvEwrJ77puBcKYO6vXHGrDtcT47ZgvyBNi11MYQ2Y4HJJ/uaDI72zWWch5a6Pi6D0mrHvm2hUbvis6CEeCV506vIi8VHjuhn618YpL/16i47H6jyvzcuS5iLFCmPAAAAbnpUWHRSYXcgcHJvZmlsZSB0eXBlIGlwdGMAAHjaPUuxDcAwCNu5oicQTEjyTkmGbh36vwqRWiPLtrDpuh+nY6Maoavo0Mka90O8OIutsKiipi0zWuQOAaOgB1ORH2bKVVB30cOduwSMGJjML9EL37QbAVBIKXIAAAAGYktHRAD/AP8A/6C9p5MAAAb0SURBVFjDtZZ7cFTVGcB/37l3HwkRhtwNQxihKvJG69gJtkVsrbESBOxYY2sTDHkgj2mp04rawrQzUKA2IjMUzJOEgHSmUIUA2umglqrQVmac0YIDVBxEAlJ2Ex4hm+zee7/+kQ2EkAC28P2zO3v3nN/v+853zj1Ct1DVBUA+njceAMvaB2wWkXL+j4jNKhqorjsR389H9W5EYhizxqSnb5EU+BZgEy0tORw8CCdOgOdBdjaMGgWRyF7gcRE5cs3QOSUhEokx6vuT8f2pqN4F9LvwB5FTGPNcl8D7nDyZw9at0NgIx4+D60JWFuTlwWOPwW237RWRCVeCNv9ktqVtbcPU8+5H9RFUJ6LqAElE9iGSxPe/BlgpicO2qi6gpSWHHTugogK++ALi8c4Zo1E4ehRUoawsR1UX9FyO079eKF7T54563jf8s2eno5qL6jBAEPkcY7ZhzBYRyVDXXZKCKyDAMBvIp6kJdu26FA4Xv+/cCffeCxMn5gPlALGnivtpMnGne+TTh1Gdguo4IIhIM2L+jJFGsay3rOwhR9ymY99W112J6nDgPJb1LzwvB/jMBsbT0tKZaVe0tnZ+ZmR0Shw7BidPAoyPlRSOVt9/UNvj01EmgPYH4oh8gJjXxTJvEAh+7FTVtQNEiwu+i+dVonor0IFlvQRkA19HzFYbAGMgEOh9YdPSSO0I8P2guu7bqGYDHiKHEdOAMdvFtvc6NQ2nuw+NFhc8lILfkoIvF9veqInEDkSiYplXbWAfWVk5jBwJhw51ZpyRcanEyJEweDBuNGoBgjF/RKRRLOsd6d//RObKNX5P72hxweQU/CtAO5b1ghmYudRvac5HdRTGNBIKf2gDmxk0KIfcXNi/Hw4evLj+aWkQicC0aXD77fjNsW1i288TCn/iVNQm+9oN0eKCPDyvojtcwuHl+D6oTk/tgO1ORW3cFpFyVc1n0qQcVOHNN+HAgc6Zhg6F3FyYPBkyMz8IRSKPXG3/R4sLpqTgw1Lw30o4/IJTWdcRKykcg+q3EDkilvVXADs17nGysjbxwAM5jBsHsRj4PjgODBmCJ9LMmTNPXBU+s+BhPO/lbvDlXXAA9f1cVLMxZq3JHnKE1F68/CiG8QDquofb//mPIW1Vq/thWUskLe1Fp2JtRx+ZT03BhwLtGGuZpIV/1wWPzS7up/H4FlTvx7K/H1m3cRuA6T6JiJSLyAQRSReRdBMI3NG2tnIOImfwvEUajz8Tm1sa6gU+LVX2oUAcYy2T8EU4AInEHcA9iOwT2/p718/mamUNjB77JyxrPiJne5NIwV9G9eZOuOmEV9VdUin1/TxU+yPyhlO7/tQ1Cwx4bqEGxo7f1E3iV9reXtQ73Foq4XB5T3hsVpGD6hSQcxjzevdnVxUAGLDgFxoYPXYTlvU0xuwB+ShafKHhusNfdKrqL+sRdd0JqN6J8L4Egx9+aYGuSkgotEnS0r8HGkkdMp1wy/qNpF2eOUDrxvWC708FghizzamqP/8/CQA4lXWedrRPSjVcF3yxhNPKncq6RG9jOt7eeTOqDyJyQozZ2fP5lxKIFhfcheetTsHbsKzFEgjWakfHo7GyJyO9jVHPuw/VEYj8TTJu+vc1CbQseNrq1UCJAJFU5kssJ7JCk4lSPHeDJpMvxGYVDexxQQmkjl5FpDFzVYV7VYFY6Yyveqf+szpW+uSICxPNn2ua55VlSDCwG8sqwrYLJRhaOXDFqqQYsxv4BN8v1kSivLuEnj8/AtX7EDkolvVubzmZHvB71HXXd76tJA5weuGzxj939od+W9sf8NWJ1G98NVK/8TWnurPbnbpX3hPbLkPkAL5f0l1Cff8hVAcj8hdn7YamKwrESgq/o8nkeuAzCQRmOjUNx1p+Pt92m46V4XkvAYcI2M29NmfdK3t6SNREZ/5oEb4/H2jDmB199ZW01lVLx3vvTFPXXYXIbgkGf+bUNJxs/vFTQb+1dT6+/yzGrJZwuNyprItf8SZcUvhNdd01qRswQAJjaiQUXuBU1/c6VqLFBXPxvIWIbJdQ+JdOdX1LbF5Zura1PY/vz8aY5SYjY03m6urkNV3HS2bcqr6Xh+ogxHwkAXunU9Nwrs8KRIue2APyrqSFlziVda2xOaXpGm9bhuoPsKyFVqbTMHDFKi82qygC4jk161q4jmFLIPgoljntVHZeInGTGcAgLOungeHDNw9YtFhjpTPGaCKxBjFvAUuvp4D0WsY5pWEJBBKZv6/0YyUz7lY3WY1Iu9j2bGfthv03XKBbU01S161C5KgEAvOc2vWfcp2jz6M4VlyYp667DpGPJRAsuRHwPgViJYV56rlViOySUGi2U9twnBsUvVdA9SaMeU2CoWec6nUxbmD8F3wVTHuzdmZWAAAAAElFTkSuQmCC";
    fetch(/*'http://localhost:8934/blink1/pattern/play?pname=policeflash'*/'http://localhost:8934/blink1/fadeToRGB?rgb=FF0000&time=0.2').then(res => res.json()).then(data => { console.log(data) }).catch(err => console.error(err)); // Documentation : https://github.com/todbot/blink1/tree/master/docs
  }


  // Quand l'élève click sur la cloche et fait une demande via le bouton Help Request
  _studentRequest = () => {
    const { batchId, user } = this.props;

    //this.setState({ isHelped: true });
    global.SOCKET.emit('newRequest', { batchId: batchId, studentId: user._id, firstname: user.firstname, lastname: user.lastname });
  }

  // _teacherTriggeredRequest = request => {
  //   this.setState({ isHelped: true, request });
  //   this.openNotification('info');
  // }

  _closedTicket = () => {
    // console.log("closed ticket");

    // this.setState({ isHelped: false, request: null });
    this.openNotificationToStudent('success');
  }

  /* cancelRequest = () => {
    console.log("cancel request");

    // this.setState({ isHelped: false, request: null });
  } */


  closeRequest = async request => {
    // const { request } = this.state;
    const { batchId, user } = this.props;

    global.SOCKET.emit('studentClosesRequest', { requestId: request._id, batchId, userId: user._id, request });
  }

  isStatusAwaySocket = checked => {
    const { batchId, user } = this.props;
    let status = checked ? 'away' : 'available';

    global.SOCKET.emit('change', { batchId: batchId, teacherId: user._id, status });
  }

  render() {
    const { icon, help, teacher, bell } = styles;
    const { request, requestList } = this.state;
    const { user } = this.props;

    const notStudent = user.type !== "student";
    let statusBadge = null;

    if (notStudent) {
      switch (user.status) {
        case 'away':
          statusBadge = 'warning';
          break;
        case 'busy':
          statusBadge = 'error';
          break;
        case 'available':
          statusBadge = 'success';
          break;
        default:
          statusBadge = null;
          break;
      }
    }

    return (<div style={help}>
      <Popover
        id="help-button"
        content={<WaitList
          userId={user._id}
          request={request}
          requestList={requestList}
          //isHelped={isHelped}
          user={user}
          studentRequest={this._studentRequest}
          cancelRequest={this.closeRequest}
          isStatusAwaySocket={this.isStatusAwaySocket}
        />}
      >
        <div style={notStudent? teacher: bell}>
          <Badge dot={notStudent} status={statusBadge}>
            <Icon theme="filled" style={icon} type="bell" />
          </Badge>
        </div>
      </Popover>
    </div>);
  }
}

function mapStateToProps({ user, batchid, batch }) {
  return { user, batchId: batchid, batch };
}

function mapDispatchToProps(dispatch) {
  return {
    _isStatusAway: function (status) {
      dispatch({ type: 'userStatus', status });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpButton);

const styles = {
  help: { marginRight: 20 },
  center: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  icon: { fontSize: 20, color: '#bcbcbc' },
  bell: { display: 'flex', alignItems: 'center' },
  teacher: { display: 'flex', alignItems: 'center', marginTop: '3px' }
}
